import { render, staticRenderFns } from "./PlanillaDigitalCursadoSecretaria.vue?vue&type=template&id=443f3cfa&scoped=true&"
import script from "./PlanillaDigitalCursadoSecretaria.vue?vue&type=script&lang=js&"
export * from "./PlanillaDigitalCursadoSecretaria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443f3cfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDataTable,VSelect,VSwitch,VTextField,VTextarea})
